export enum BENEFICIARY_KIND {
    SYSTEM = 'system',
    WHITELABEL = 'whitelabel',
    SALESMAN_LEAD = 'salesmanlead',
    SALESMAN = 'salesman',
    AGENT = 'agent'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/api/entity/beneficiary-kind.model.ts